import axios from '~/utils/axiosInstance';

export interface CreateFromDocumentUploadResponse {
  presignedUrl: string;
  s3Key: string;
}

export interface CreateFromDocumentStartResponse {
  apiEvent: { id: string };
}

export interface CreateFromDocumentPollResponse {
  status: string;
  statusMessage?: string;
  result?: {
    type: 'project';
    projectId: string;
    projectName?: string;
  } | {
    type: 'portfolio';
    portfolioId: string;
    portfolioName?: string;
    projectIds: string[];
  } | {
    message: string;
    details?: string;
  };
}

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export async function getCreateFromDocumentUploadUrl(
  installerId: string,
  fileName: string,
  fileSizeBytes: number
): Promise<CreateFromDocumentUploadResponse> {
  const response = await axios.post('/admin/create-from-document/upload', {
    installerId,
    fileName,
    fileSizeBytes,
  });
  return response.data;
}

export async function startCreateFromDocument(params: {
  s3Key: string;
  fileName?: string;
  installerId: string;
  idempotencyKey?: string;
  additionalContext?: string;
}): Promise<CreateFromDocumentStartResponse> {
  const response = await axios.post('/admin/create-from-document/start', params);
  return response.data;
}

export async function pollCreateFromDocument(
  apiEventId: string
): Promise<CreateFromDocumentPollResponse> {
  const response = await axios.get(
    `/admin/create-from-document/async-request/${apiEventId}/poll`
  );
  return response.data;
}
